import React from "react";
import {
  AppHeader,
  ScreenshotsGallery,
  AppDescription,
  AppFeatures,
  AppReviews,
  AppInformation,
  VersionHistory,
  AppFooter,
} from "./components";

// Add custom styles for scrollbar hiding
const customStyles = `
  .scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
`;

const AppStorePage: React.FC = () => {
  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: customStyles }} />
      <div className="min-h-screen bg-white">
        {/* Header */}
        <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
          <div className="max-w-6xl mx-auto px-4 py-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <img src="/logo/icon-full-color.png" alt="App Store" className="h-6 md:h-8" />
                <span className="text-lg md:text-xl font-semibold text-black">
                  App Store
                </span>
              </div>
              <p className="text-xs md:text-sm text-gray-600 hidden sm:block">
                Mở Mac App Store để mua và tải ứng dụng.
              </p>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="max-w-6xl mx-auto px-4 py-8">
          {/* App Header Section */}
          <AppHeader />

          {/* Screenshots Section */}
          <ScreenshotsGallery />

          {/* App Description Section */}
          <AppDescription />

          {/* Features Section */}
          <AppFeatures />

          {/* Reviews Section */}
          <AppReviews />

          {/* App Information */}
          <AppInformation />

          {/* Version History */}
          <VersionHistory />

          {/* Footer */}
          <AppFooter />
        </main>
      </div>
    </>
  );
};

export default AppStorePage;
